export const API_URL = {
    COMMON: {
        DISTRICT: '/v2/wms/common/district',
    },
    MAP: {
        STATAION_REGIONS: '/homepage/station/regions',
        STATION_LIST: '/homepage/station',
        NETWORK_LIST: '/homepage/service-shop',
    },
}
